import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Account from "../pages/Dashboard/account";
import Deposit from "../pages/Dashboard/deposit";
import Transactions from "../pages/Dashboard/transactions";
import Wallet from "../pages/Dashboard/wallet";
import Withdraw from "../pages/Dashboard/withdraw";

const DashboardRoute = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/dashboard">
          <Account />
        </Route>
        <Route path="/dashboard/deposit">
          <Deposit />
        </Route>
        <Route path="/dashboard/wallet">
          <Wallet />
        </Route>
        <Route path="/dashboard/transactions">
          <Transactions />
        </Route>
        <Route path="/dashboard/withdraw">
          <Withdraw />
        </Route>
      </Switch>
    </Router>
  );
};

export default DashboardRoute;
